import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ContractService { 
  baseUrl = environment.baseUrl;
  
  constructor(
    private http: HttpClient, 
  ) { }

  getContracts$(uuid: string, page: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.submissions}`;
    let offset = page * 10;
    console.log(url + 'filter/state?is_accepted=true&is_signed=true&uuid=' + uuid + '&offset=' + offset);
    return this.http.get<any>(url + 'filter/state?is_accepted=true&is_signed=true&uuid=' + uuid + '&offset=' + offset);
  }
  
  getRoofTypes$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'roof-types?uuid=' + uuid);
  }

  addContract$(uuid: string, submissionInfo: any[]): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.submissions}`;
    return this.http.post<any>(url + '?uuid=' + uuid, submissionInfo, httpOptions);
  }

  getContract$(submissionId: number, uuid: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.submissions}`;
    return this.http.get<any>(url + submissionId + '?uuid=' + uuid);
  }

  updateContract$(submissionId: number, uuid: string, contractInfo: any[]): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.contracts}`;
    return this.http.put<any>(url + submissionId + '?uuid=' + uuid, contractInfo, httpOptions);
  }

  updateContractState$(submissionId: number, uuid: string, submissionInfo: any[]): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.submissions}`;
    return this.http.put<any>(url + submissionId + '/state?uuid=' + uuid, submissionInfo, httpOptions);
  }

  searchStateContract$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.contracts}`;
    let offset = page * 10;
    return this.http.get<any>(url + '/filter/state?' + search + '&uuid=' + uuid + '&offset=' + offset);
  }

  searchContract$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.submissions}`;
    let offset = page * 10;
    return this.http.get<any>(url + 'search/contracts?query=' + search + '&uuid=' + uuid + '&offset=' + offset);
  }
  //add invoice button on contracts
  addInvoiceToContract(uuid: string, submissionId: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.invoices}`;
    return this.http.post<any>(url + '?submission_id='+ submissionId +'&uuid=' + uuid, httpOptions);
  }
  //add order button on contracts
  addOrderToContract(uuid: string, submissionId: any[]): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    return this.http.post<any>(url + '?uuid=' + uuid, submissionId, httpOptions);
  }
}
